import FieldConfig from "../../../proto/field-config"
import FieldEstimate from "../../../generic/estimate/estimate"
import {FieldAccess} from "../../../const"
import Project from "../../../../model2/project/project"
import ItemModelV2 from "../../../../model2/item2/item-model"

export default class FieldProjectEstimate extends FieldEstimate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Project estimate";
        this.label          = _.get(config, 'label', "Project estimate")
        this.variableName   = "{PROJECT-ESTIMATE}"

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeEstimate
    }

    access(model:any) : FieldAccess {
        if (this.isDisabled) return FieldAccess.READ
        if (gd.ac.check.project.fullAccess(model?.id)) return FieldAccess.WRITE

        return FieldAccess.READ;
    }

    tableCellOnValueChange = async (item: ItemModelV2, value: number) => {

        item.project.estimate = value ? value : null

        item.project.save()
    }

}
